<template>
  <CRow>
    <CCol col="12" sm="4">
      <CSelect
        :value.sync="selectedCourseTeacherId"
        :options="courseTeacherSelectOptions"
        v-on:change="refreshCalendar"
      />
    </CCol>
    <CCol col="12" xl="12">
      <v-calendar
        v-if="selectedCourseTeacherId"
        style="width: 100%; margin-bottom: 20px;"
        :masks="masks"
        :first-day-of-week="1"
        :attributes="attributes"
        disable-page-swipe
        :from-date="selectedDate"
        :from-page.sync="fromPage"
      >
        <div
          slot="day-content"
          slot-scope="{ day, attributes }"
          style="text-align: center; cursor: pointer;"
          :class="day.date.getTime() === selectedDate.getTime() ? 'selected-date-slot' : ''"
        >
          <div @click.self="onDateClick(day.date)">{{ day.day }}</div>
          <div style="padding: 10px;" @click.self="onDateClick(day.date)">
            <div>
              <p
                :key="attr.key"
                v-for="attr in attributes"
                @click.self="onDateClick(day.date)"
              >
                <label class="c-switch c-switch-sm c-switch-pill c-switch-dark">
                  <input
                    type="checkbox" 
                    class="c-switch-input" 
                    :checked="attr.customData.isOpen"
                    v-on:click.stop="(event) => onDaySwitchChange(event, day.date)"
                  />
                  <span class="c-switch-slider"></span>
                </label>
              </p>
              <CBadge 
                style="position: absolute; top: 65px;" 
                color="success" 
                shape="pill"
                v-if="confirmedOrdersAmountMap[day.date.format('yyyy-MM-dd')]"
                >
                {{confirmedOrdersAmountMap[day.date.format('yyyy-MM-dd')]}}
              </CBadge>
            </div>
          </div>
        </div>
      </v-calendar>
    </CCol>
    <CCol col="12" xl="6">
      <CCard>
        <CCardHeader>
          {{i18nMessage.Unconfirmed}}
        </CCardHeader>
        <CCardBody>
          <CDataTable
            outlined
            hover
            striped
            tableFilter
            columnFilter
            sorter
            :fields="courseUnconfirmedOrdersUiMetaWithAction"
            :items="courseUnconfirmedOrders"
            :items-per-page="20"
            clickable-rows
            :active-page="activePage"
            :pagination="{ align: 'center'}"
            :noItemsView="{ noResults: i18nMessage.NoFilteredResultsAvailable, noItems: i18nMessage.NoItemsAvailable }"
          >
            <template #order_no="{item}">
              <a class="btn btn-link" :href="$router.resolve({path: `course-order/${item.invisible_id}`}).href" >#{{item.order_no}}</a>
            </template>
            <template #action="{item}">
              <td style="width: 20px;">
                <CButtonToolbar>
                  <CButton 
                    color="ghost-success" 
                    shape="pill"
                    @click="onUnconfirmedOrderClick(item)"
                  >
                    <CIcon size="sm" name="cil-cursor"/>
                  </CButton>
                </CButtonToolbar>
              </td>
            </template>
            <template #unconfirmed_course_detail="{item}">
              <td>
                <div>{{item.unconfirmed_course_detail.course_name}}</div>
                <div>{{item.unconfirmed_course_detail.reserved_participants_num}}</div>
                <template v-if="item.unconfirmed_course_detail.reserved_periods">
                  <div v-for="period in item.unconfirmed_course_detail.reserved_periods.split(',')" :key="period">
                    {{new Date(period.split('~')[0]).format('yyyy-MM-dd hh:mm')}} ~ {{new Date(period.split('~')[1]).format('yyyy-MM-dd hh:mm')}}
                  </div>
                </template>
              </td>
            </template>
            <template #created_at="{item}">
              <td>
                {{item.created_at ? new Date(item.created_at).format('yyyy-MM-dd') : ''}}
              </td>
            </template>
          </CDataTable>
          <div style="text-align: center; color: #4f5d73">{{i18nMessage.TotalRows}}: {{courseUnconfirmedOrders.length}}</div>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="12" xl="6">
      <CCard style="">
        <CCardHeader>
          {{selectedDate.toLocaleDateString('zh-TW')}}
        </CCardHeader>
        <CCardBody>
          <div>
            <div style="100%; padding-left: 15px;">
              <CRow
                v-for="(hourSlot, index) in selectedDateHourSlots"
                :key="hourSlot.date.toISOString()"
              >
                <CCol col="1" style="top: -10px; padding-left: 0px; padding-right: 0px; text-align: right;">
                  <span>{{hourSlot.date.toLocaleTimeString('en-US', { hour: 'numeric', hour12: true })}}</span>
                </CCol>
                <CCol col="11">
                  <div :style="'width: 100%; border: 1px solid #ccc; ' + (index > 0 ? 'border-top: 0px;' : '') + 'height: 50px;'">
                    <div style="padding-top: 12px;">
                      <label class="c-switch c-switch-sm c-switch-pill c-switch-dark">
                        <input 
                          type="checkbox" 
                          class="c-switch-input" 
                          :checked="hourSlot.isOpen"
                          @click.stop="(event) => onDayHourSwitchChange(event, hourSlot.date)"
                        />
                        <span class="c-switch-slider"></span>
                      </label>
                    </div>
                  </div>
                </CCol>
              </CRow>
              <div>
                <div style="position: absolute; top: 0px; left: 125px; top: 66px;">
                  <div 
                    v-for="slot in confirmedOccuppiedSlots" 
                    :key="'slot-' + slot.startX + '-' + slot.startY + '-' + slot.size"
                    v-bind:style="{ 
                      position: 'absolute', 
                      top: (50 * slot.startY) + 'px',
                      left: (100 *  slot.startX) + 'px',
                      width: 100 + 'px',
                      height: (50 *  slot.size) + 'px',
                      border: '1px solid #ccc',
                      backgroundColor: '#eee',
                      textAlign: 'center',
                    }"
                  >
                    <div>
                      <a class="btn btn-link" :href="$router.resolve({path: `course-order/${slot.element.invisible_id}`}).href" >#{{slot.element.order_no}}</a>
                      <CIcon 
                        v-c-tooltip="{
                          content: slot.element.reserved_note,
                          placement: 'top-start',
                        }"
                        v-if="slot.element.reserved_note"
                        name="cil-notes"
                      />
                    </div>
                    <div
                      v-c-tooltip="{
                        content: slot.element.confirmed_course_name,
                        placement: 'bottom-start',
                      }"
                    >{{slot.element.confirmed_course_name.length > 6 ? slot.element.confirmed_course_name.slice(0, 6) + '...' : slot.element.confirmed_course_name}}</div>
                    <div>{{slot.element.confirmed_participants_num}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
    <CModal
      v-if="courseUnconfirmedOrder.unconfirmed_course_order_detail"
      :show.sync="modelShowOrderId[courseUnconfirmedOrder.invisible_id]"
      style="z-index: 1030;"
    >
      <div>{{courseUnconfirmedOrder.unconfirmed_course_order_detail.contact_name}}</div>
      <div>{{courseUnconfirmedOrder.unconfirmed_course_order_detail.contact_email}}</div>
      <div>{{courseUnconfirmedOrder.unconfirmed_course_order_detail.contact_cellphone}}</div>
      <div>{{courseUnconfirmedOrder.unconfirmed_course_order_detail.contact_home_phone}}</div>
      <div><a target="_blank" :href="$router.resolve({path: `member/${courseUnconfirmedOrder.unconfirmed_course_order_detail.member_id}`}).href">{{i18nMessage.MemberDetail}}</a></div>
      <br/>
      <hr/>
      <div><a target="_blank" :href="$router.resolve({path: `course/${courseUnconfirmedOrder.unconfirmed_course_order_detail.reserved_course_id}`}).href">{{courseUnconfirmedOrder.unconfirmed_course_order_detail.reserved_course_name}}</a></div>
      <div>{{courseUnconfirmedOrder.unconfirmed_course_order_detail.reserved_participants_num}}</div>
      <template v-if="courseUnconfirmedOrder.unconfirmed_course_order_detail.reserved_periods">
        <div v-for="period in courseUnconfirmedOrder.unconfirmed_course_order_detail.reserved_periods.split(',')" :key="period">
          {{new Date(period.split('~')[0]).format('yyyy-MM-dd hh:mm')}} ~ {{new Date(period.split('~')[1]).format('yyyy-MM-dd hh:mm')}}
        </div>
      </template>
      <div>{{courseUnconfirmedOrder.unconfirmed_course_order_detail.reserved_note}}</div>
      <br/>
      <hr/>
      <AppForm
        :key="'app-form-' + courseUnconfirmedOrder.invisible_id"
        :vo-name="'CourseOrderUnconfirmedUpdateVo'"
        :data="courseUnconfirmedOrder" 
        @init="onFormChange"
        @changed="onFormChange"
      />
      <template slot=header>
        <h5>#{{courseUnconfirmedOrder.unconfirmed_course_order_detail.order_no}}</h5>
      </template>
      <template slot=footer>
        <CButton 
          color="primary"
          @click="onApplyClick(courseUnconfirmedOrder.invisible_id)"
        >{{i18nMessage.Apply}}</CButton>
        <CButton 
          color="primary"
          @click="onApplyClick(courseUnconfirmedOrder.invisible_id, true)"
        >{{i18nMessage.ApplyAndSendEmail}}</CButton>
        <CButton
          color="secondary"
          @click="forceSetModelShowOrderId(courseUnconfirmedOrder.invisible_id, false)"
        >{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import VCalendar from 'v-calendar/lib/components/calendar.umd'
import AppForm from '../../components/AppForm'

export default {
  name: 'CourseCalendar',
  components: {
    VCalendar,
    AppForm,
  },
  data () {
    let currentDate = null
    if (this.$route.query.date) {
      currentDate = new Date(this.$route.query.date)
    } else {
      currentDate = new Date()
    }
    currentDate.setHours(0, 0, 0, 0)
    
    return {
      activePage: 1,
      UpdateOpenSlotsFunc: null,
      fromPage: null,
      selectedCourseTeacherId: null,
      courseTeacherSelectOptions: [],
      masks: {
        weekdays: 'WWW',
      },
      startHour: 8,
      endHour: 23,
      attributes: [],
      selectedDate: currentDate,
      tmpOpenSlots: {},
      confirmedOrdersAmountMap: {},
      selectedDateHourSlotsMap: {},
      selectedDateHourSlots: [],
      modelShowOrderId: {},
      tmpCourseOrder: {},
    };
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      courseTeacherOpenSlots: state => state.course.courseTeacherOpenSlots,
      courseTeachers: state => state.course.courseTeachers,
      courseConfirmedTimesOrders: state => state.course.courseConfirmedTimesOrders,
      courseUnconfirmedOrders: state => state.course.courseUnconfirmedOrders,
      courseUnconfirmedOrdersUiMeta: state => state.course.courseUnconfirmedOrdersUiMeta,
      courseUnconfirmedOrder: state => state.course.courseUnconfirmedOrder,
    }),
    courseUnconfirmedOrdersUiMetaWithAction () {
      const uiMetaWithAction = this.courseUnconfirmedOrdersUiMeta.slice()
      uiMetaWithAction.push({
        key: 'action',
        label: '',
      })
      return uiMetaWithAction
    },
    confirmedOccuppiedSlots() {
      const confirmedOccuppiedSlots = {}

      function isOccupied(startX, startY, size) {
        let isOccupied = false
        for (let i = startY; i < startY + size; i++) {
          if (confirmedOccuppiedSlots[startX] && confirmedOccuppiedSlots[startX][i]) {
            isOccupied = true
            break
          }
        }
        if (isOccupied) {
          return true
        } else {
          for (let i = startY; i < startY + size; i++) {
            if (!confirmedOccuppiedSlots[startX]) {
              confirmedOccuppiedSlots[startX] = {}
            }
            confirmedOccuppiedSlots[startX][i] = true
          }
          return false
        }
      }

      function getNextStartX(startY, size) {
        let nextStartX = 0;
        while (isOccupied(nextStartX, startY, size)) {
          nextStartX += 1
        }
        return nextStartX
      }

      const result = []
      const startDate = this.selectedDate
      const endDate = new Date(startDate.getTime() + 86400000) // add one day

      for (const courseOrder of this.courseConfirmedTimesOrders) {
        const periods = courseOrder.confirmed_periods.split(',')
        for (const period of periods) {
          const start = new Date(period.split('~')[0])
          const end = new Date(period.split('~')[1])
          if (startDate > start || endDate < end) {
            continue
          } 
          const size = end.getHours() - start.getHours()
          const startY = start.getHours() - this.startHour
          const startX = getNextStartX(startY, size)
          result.push({
            startX,
            startY,
            size,
            element: courseOrder,
          })
        }
      }
      return result
    },
  },
  methods: {
    ...mapActions({
      addOrDeleteCourseTeacherOpenSlots: 'course/addOrDeleteCourseTeacherOpenSlots',
      listCourseTeachers: 'course/listCourseTeachers',
      listCourseTeacherOpenSlots: 'course/listCourseTeacherOpenSlots',
      listConfirmedTimeSlotsCourserOrders: "course/listConfirmedTimeSlotsCourserOrders",
      listCourseUnconfirmedOrders: "course/listCourseUnconfirmedOrders",
      getCourseUnconfirmedOrder: "course/getCourseUnconfirmedOrder",
      updateCourseUnconfirmedOrder: "course/updateCourseUnconfirmedOrder"
    }),
    ...mapMutations({
      setCourseUnconfirmedOrder: "course/setCourseUnconfirmedOrder",
      setCourseUnconfirmedOrders: "course/setCourseUnconfirmedOrders",
      setCourseConfirmedTimesOrders: "course/setCourseConfirmedTimesOrders",
      setCourseTeacherOpenSlots: "course/setCourseTeacherOpenSlots",
    }),
    onDateClick(date) {
      this.setSelectedDate(date)
      this.refreshCalendar(false)
    },
    setSelectedDate(date) {
      this.selectedDate = date
      this.$router.push({ path: 'course-calendar', query: { date: this.selectedDate.format('yyyy-MM-dd') }})
    },
    onDaySwitchChange(event, date) {
      const startDate = date
      const endDate = new Date(startDate.getTime() + 86400000) // add one day
      this.tmpOpenSlots[startDate.toISOString() + "~" + endDate.toISOString()] = !event.target.checked
      this.debounceUpdateOpenSlots()
    },
    onDayHourSwitchChange(event, hourDate) {
      this.selectedDateHourSlotsMap[hourDate.toISOString()].isOpen = event.target.checked
      this.debounceUpdateHourlyOpenSlots()
    },
    debounceUpdateHourlyOpenSlots(waitTime) {
      if (this.debounceUpdateHourlyOpenSlotsFunc) clearTimeout(this.debounceUpdateHourlyOpenSlotsFunc)
      this.debounceUpdateHourlyOpenSlotsFunc = setTimeout(() => {
        const addOrUpdateOpenSlots = []
        // Delete All day first
        const startDate = new Date(this.selectedDate)
        const endDate = new Date(startDate.getTime() + 86400000) // add one day
        addOrUpdateOpenSlots.push({
          start_time: startDate.toISOString(),
          end_time: endDate.toISOString(),
          course_teacher_id: this.selectedCourseTeacherId,
          is_delete: true
        })
        // Add other hourly open slots
        for (const key in this.selectedDateHourSlotsMap) {
          if (this.selectedDateHourSlotsMap[key].isOpen) {
            const startHourlyDate = new Date(key)
            const endHourlyDate = new Date(startHourlyDate.getTime() + 3600000) // add one hour
            addOrUpdateOpenSlots.push({
              start_time: startHourlyDate.toISOString(),
              end_time: endHourlyDate.toISOString(),
              course_teacher_id: this.selectedCourseTeacherId,
              is_delete: false,
            })
          }
        }
        this.selectedDateHourSlotsMap = {}
        this.addOrDeleteCourseTeacherOpenSlots(addOrUpdateOpenSlots)
          .then(() => {
            this.refreshCalendar(true)
          })
      }, waitTime ? waitTime : 1000)
    },
    debounceUpdateOpenSlots(waitTime) {
      if (this.debounceUpdateOpenSlotsFunc) clearTimeout(this.debounceUpdateOpenSlotsFunc)
      this.debounceUpdateOpenSlotsFunc = setTimeout(() => {
        if (this.tmpOpenSlots.length == 0) {
          return
        }
        const addOrUpdateOpenSlots = []
        for (const key in this.tmpOpenSlots) {
          const value = this.tmpOpenSlots[key]
          addOrUpdateOpenSlots.push({
            start_time: key.split('~')[0],
            end_time: key.split('~')[1],
            course_teacher_id: this.selectedCourseTeacherId,
            is_delete: value
          })
        }
        this.tmpOpenSlots = {}
        this.addOrDeleteCourseTeacherOpenSlots(addOrUpdateOpenSlots)
          .then(() => {
            this.refreshCalendar(true)
          })
      }, waitTime ? waitTime : 1000)
    },
    goBack() {
      this.$router.push({path: '/course'})
    },
    refreshCalendar(reloadFullCalendar) {
      const year = this.fromPage.year
      const month = this.fromPage.month-1
      const startDate = new Date(year, month, 1)
      const endDate = this.addMonths(new Date(year, month, 1), 1)
      new Promise((resolve, reject) => {
        if (reloadFullCalendar) {
          this.listCourseTeacherOpenSlots({
            courseTeacherId: this.selectedCourseTeacherId,
            startTime: startDate.toISOString(),
            endTime: endDate.toISOString(),
          }).then(() => {
            return this.listConfirmedTimeSlotsCourserOrders({
              startDatetime: startDate.toISOString(),
              endDatetime: endDate.toISOString(),
            })
          }).then(() => {
            this.confirmedOrdersAmountMap = {}
            for (const courseOrder of this.courseConfirmedTimesOrders) {
              const firstPeriod = courseOrder.confirmed_periods.split(',')[0]
              const courseDate = new Date(firstPeriod.split('~')[0])
              courseDate.setHours(0, 0, 0, 0)
              const courseDateKey = courseDate.format('yyyy-MM-dd')
              if (!(courseDateKey in this.confirmedOrdersAmountMap)) {
                this.confirmedOrdersAmountMap[courseDateKey] = 1
              } else {
                this.confirmedOrdersAmountMap[courseDateKey] += 1
              }
            }
            resolve()
          })
        } else {
          resolve()
        }
      }).then(() => {
        return this.listCourseUnconfirmedOrders()
      }).then(() => {
        const newAttributesMap = {}
        for(var loopTime = startDate.getTime(); loopTime < endDate.getTime(); loopTime += 86400000) {
          const loopDate = new Date(loopTime)
          newAttributesMap[loopDate.toISOString()] = {
            key: loopDate.toISOString(),
            customData: {
              isOpen: false,
            },
            dates: loopDate,
          }
        }
        const openDates = {}
        for (const openSlot of this.courseTeacherOpenSlots) {
          const startDateOfStartTime = new Date(openSlot.start_time)
          startDateOfStartTime.setHours(0,0,0,0)
          openDates[startDateOfStartTime.toISOString()] = true
        }
        for (const openDate in openDates) {
          newAttributesMap[openDate].customData.isOpen = true
        }
        const newAttributes = []
        for (const key in newAttributesMap) {
          newAttributes.push(newAttributesMap[key])
        }
        this.attributes = newAttributes
        
        const selectedDateOpenSlots = []
        for (const openSlot of this.courseTeacherOpenSlots) {
          const startDateOfStartTime = new Date(openSlot.start_time)
          startDateOfStartTime.setHours(0,0,0,0)
          if (startDateOfStartTime.getTime() === this.selectedDate.getTime()) {
            selectedDateOpenSlots.push(openSlot)
          }
        }

        const selectedDateHourSlotsMap = {}
        for(var loopTime = this.selectedDate.getTime() + (3600000 * this.startHour); loopTime < this.selectedDate.getTime() + (3600000 * this.endHour); loopTime += 3600000) {
          const loopDate = new Date(loopTime)
          const isOpen = false
          for (const selectedDateOpenSlot of selectedDateOpenSlots) {
            if (loopDate >= new Date(selectedDateOpenSlot.start_time) && loopDate < new Date(selectedDateOpenSlot.end_time)) {
              isOpen = true
              break
            }
          }
          selectedDateHourSlotsMap[loopDate.toISOString()] = {
            date: loopDate,
            isOpen: isOpen,
          }
        }
        const selectedDateHourSlots = []
        for (const key in selectedDateHourSlotsMap) {
          selectedDateHourSlots.push(selectedDateHourSlotsMap[key])
        }
        this.selectedDateHourSlotsMap = selectedDateHourSlotsMap
        this.selectedDateHourSlots = selectedDateHourSlots
      })
    },
    addMonths(date, months) {
      var d = date.getDate();
      date.setMonth(date.getMonth() + +months);
      if (date.getDate() != d) {
        date.setDate(0);
      }
      return date;
    },
    onFormChange (data) {
      this.tmpCourseOrder = {...data}
    },
    onUnconfirmedOrderClick(item) {
      this.getCourseUnconfirmedOrder(item.invisible_id)
        .then(() => {
          this.forceSetModelShowOrderId(item.invisible_id, true)
        })
    },
    forceSetModelShowOrderId(id, showModal) {
      this.modelShowOrderId[id] = showModal
      this.$forceUpdate()
    },
    onApplyClick(id, sendEmail) {
      const tmpCourseOrder = this.tmpCourseOrder
      this.updateCourseUnconfirmedOrder({
        courseOrder: this.tmpCourseOrder,
        sendEmail: sendEmail,
      }).then(() => {
        const firstPeriod = this.tmpCourseOrder.unconfirmed_confirmed_periods.split(',')[0]
        const courseDate = new Date(firstPeriod.split('~')[0])
        courseDate.setHours(0, 0, 0, 0)
        this.setSelectedDate(courseDate)
        this.$router.go()
      })
    }
  },
  created() {
    this.listCourseTeachers().then(() => {
      this.courseTeacherSelectOptions = []
      for (const courseTeacher of this.courseTeachers) {
        this.courseTeacherSelectOptions.push({
          'label': courseTeacher.name,
          'value': courseTeacher.invisible_id,
        })
      }
      if (this.courseTeacherSelectOptions.length > 0) {
        this.selectedCourseTeacherId = this.courseTeacherSelectOptions[0].value
      }
    })
  },
  destroyed() {
    this.setCourseUnconfirmedOrder({})
    this.setCourseUnconfirmedOrders([])
    this.setCourseConfirmedTimesOrders([])
    this.setCourseTeacherOpenSlots([])
  },
  watch: {
    fromPage(newVal) {
      if (newVal) {
        this.refreshCalendar(true)
      }
    },
  },
}
</script>

<style scoped>
>>> .vc-day {
  width: 100%;
  border: 1px solid var(--light);
  border-left-width: 0;
  border-top-width: 0;
}
>>> .vc-day.on-top {
  border-top-width: 1px;
}

>>> .vc-day.on-left {
  border-left-width: 1px;
}

.selected-date-slot {
  background-color: #eee;
}
</style>